import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreloadingStrategyService } from '@servicios/_helpers/preloading-strategy.service';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard, ClientAuthGuard } from './auth/_helpers/auth.guard';
import { BackupComponent } from './backup/backup.component';
import { LoadingComponent } from './loading/loading.component'
import { PrivacyComponent } from './privacy/privacy.component';
import { RegisterComponent } from './auth/register/register.component';
import { TableTestComponent } from './_sharedComponents/table-test/table-test.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'javi', component: TableTestComponent },
  { path: 'backupPage', component: BackupComponent },
  { path: 'loadingPage', component: LoadingComponent },
  { path: 'privacidad', component: PrivacyComponent },
  {
    path: 'public/sample/:token',
    loadComponent: () => import('./_featuresModules/sample-public-view/sample-public-view.component').then(m => m.SamplePublicViewComponent)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    data: { preload: true },
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
  },
  { 
    path: 'loginClient',    
    canActivate: [ClientAuthGuard],
    component: LoginComponent, 
  },
  { path: 'loginClient/register', component: RegisterComponent },
  { path: 'clients', loadChildren: () => import('./_featuresModules/clients/clients.module').then(m => m.ClientsModule) },
  { path: '**', redirectTo: '' },
];
@NgModule({

  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    preloadingStrategy: PreloadingStrategyService
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
